import { router } from "../router/router.js";
import { PermissionCode } from "../../permissions/permissions.js";
import { contextStore } from "../auth/context-store.js";
import { StudioArtifactType } from "../../studio/studio-definition.js";
import { StudioVersionStatus } from "../../studio/studio-version.js";

const template = document.createElement("template");
template.innerHTML = `
  <div class="studio-page" style="display: flex; flex-direction: column; height: 100%; gap: var(--space-4);">
    <header class="studio-header" style="display: flex; justify-content: space-between; align-items: center;">
      <div>
        <h1 style="color: var(--color-text-muted); font-size: var(--font-size-2xl);">INSPECT IA Studio</h1>
        <p style="color: var(--color-graphite-400); font-size: var(--font-size-sm);">Manage and publish system extensions, forms, and workflows.</p>
      </div>
      <button id="btn-new" class="btn-primary" style="background-color: var(--color-primary); color: var(--color-text-primary); border: none; padding: var(--space-2) var(--space-4); border-radius: var(--radius-md); font-weight: 500; cursor: pointer;">
        New Artifact
      </button>
    </header>

    <div class="studio-filters" style="display: flex; gap: var(--space-4); margin-bottom: var(--space-4);">
      <select id="filter-type" style="padding: var(--space-2); border: 1px solid var(--color-graphite-300); border-radius: var(--radius-md);">
        <option value="">All Types</option>
        ${Object.values(StudioArtifactType).map(type => `<option value="${type}">${type}</option>`).join("")}
      </select>
      
      <select id="filter-status" style="padding: var(--space-2); border: 1px solid var(--color-graphite-300); border-radius: var(--radius-md);">
        <option value="">All Statuses</option>
        ${Object.values(StudioVersionStatus).map(status => `<option value="${status}">${status}</option>`).join("")}
      </select>
      
      <input type="text" id="filter-search" placeholder="Search by name or code..." style="flex: 1; padding: var(--space-2); border: 1px solid var(--color-graphite-300); border-radius: var(--radius-md);">
    </div>

    <div class="studio-list" style="flex: 1; background: var(--color-surface-primary); border-radius: var(--radius-md); border: 1px solid var(--color-graphite-300); overflow: hidden;">
      <table style="width: 100%; border-collapse: collapse; text-align: left;">
        <thead style="background: var(--color-graphite-50); border-bottom: 1px solid var(--color-graphite-300);">
          <tr>
            <th style="padding: var(--space-3); font-weight: 500; color: var(--color-text-secondary);">Name</th>
            <th style="padding: var(--space-3); font-weight: 500; color: var(--color-text-secondary);">Code</th>
            <th style="padding: var(--space-3); font-weight: 500; color: var(--color-text-secondary);">Type</th>
            <th style="padding: var(--space-3); font-weight: 500; color: var(--color-text-secondary);">Status</th>
            <th style="padding: var(--space-3); font-weight: 500; color: var(--color-text-secondary);">Version</th>
            <th style="padding: var(--space-3); font-weight: 500; color: var(--color-text-secondary);">Actions</th>
          </tr>
        </thead>
        <tbody id="table-body">
          <!-- Populated by JS -->
        </tbody>
      </table>
      
      <div id="empty-state" style="display: none; padding: var(--space-8); text-align: center;">
        <p style="color: var(--color-graphite-400);">No artifacts found. Create one to get started.</p>
      </div>
    </div>
  </div>
`;

export default class StudioPage extends HTMLElement {
  public constructor() {
    super();
    this.appendChild(template.content.cloneNode(true));
  }

  public connectedCallback(): void {
    if (!contextStore.hasPermission(PermissionCode.StudioCreate)) {
      router.navigate("/");
      return;
    }
    
    // Simulate backend fetch
    Promise.resolve([]).then(() => {
      this.renderEmpty();
    });

    this.querySelector("#btn-new")?.addEventListener("click", () => {
      router.navigate("/studio/forms");
    });
  }

  private renderEmpty(): void {
    const tbody = this.querySelector("#table-body");
    const emptyState = this.querySelector("#empty-state") as HTMLElement;
    
    if (tbody && emptyState) {
      tbody.innerHTML = "";
      emptyState.style.display = "block";
    }
  }
}

if (!customElements.get("app-studio-page")) {
  customElements.define("app-studio-page", StudioPage);
}

